import actions from './actions';

const {
  LIST_MEMBRESIAS_PACIENTE,
  LIST_MEMBRECIAS_SELECTBOX,
  READ_MEMBRESIA_PACIENTE,
  CREATE_MEMBRESIA_PACIENTE,   
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const membresiaCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_MEMBRESIAS_PACIENTE:
      return {
        ...state,
        data: data
      }
    case LIST_MEMBRECIAS_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case READ_MEMBRESIA_PACIENTE:
      return {
        ...state,
        record: data
      }
    case CREATE_MEMBRESIA_PACIENTE:
        return {
          ...state,
          record: data
        }  
    default:
      return state;
  }
};


export default membresiaCrudReducer;
